import type { FC } from 'react'

export interface GroupVersionProps {
  groupVersion: string
}

export const GroupVersion: FC<GroupVersionProps> = ({ groupVersion }) => {
  return <span>{groupVersion}</span>
}
